import React from "react";

import { Bulb } from "@styled-icons/ionicons-outline/Bulb";

import { useAppState } from "contextApi/appContext";
import { CREATE_TAB_NEW_UNTIL_MILLIS } from "constants/featureAnnouncements";
import { NavItemList, NavItem, NavItemNewTag } from "./styles";
import NavItemIcon from "./NavItemIcon";
import {
  HomeIcon,
  CalendarIcon,
  SparklesIcon,
  EyeIcon,
  CompassIcon,
  AnalyticsIcon,
} from "./icons";

const MainNavigation = React.memo(({ accountId, wasClicked }: {accountId: string, wasClicked: () => void}) => {
  const client = useAppState(state => state.clientSettings.client);
  const showIdeasPageRevamp = useAppState(state => state.showIdeasPageRevamp);
  const showContentFactoryTab = useAppState(state => state.showContentFactoryTab);
  const isCreateTabNew = Date.now() < CREATE_TAB_NEW_UNTIL_MILLIS;

  return (
    <NavItemList onClick={wasClicked}>
      <NavItem to={`/accounts/${accountId}/dashboard`}>
        <NavItemIcon icon={<HomeIcon size={20} />} />
        <label>Home</label>
      </NavItem>
      {showIdeasPageRevamp && (
        <NavItem to={`/accounts/${accountId}/ideas`}>
          <NavItemIcon icon={<Bulb size={20} strokeWidth={40} />} />
          <label>Ideas</label>
        </NavItem>
      )}
      <NavItem to={`/accounts/${accountId}/schedule`}>
        <NavItemIcon icon={<CalendarIcon size={20} />} />
        <label>Calendar</label>
      </NavItem>
      {showContentFactoryTab && <NavItem to={`/accounts/${accountId}/content-factory`}>
        <NavItemIcon icon={<SparklesIcon size={20} />} />
        <label>Create</label>
        {isCreateTabNew && <NavItemNewTag>New</NavItemNewTag>}
      </NavItem>}
      {!showIdeasPageRevamp && (
        <NavItem to={`/accounts/${accountId}/ideas`}>
          <NavItemIcon icon={<EyeIcon size={20} />} />
          <label>Ideas</label>
        </NavItem>
      )}
      {client !== "telenet" && (
        <NavItem to={`/accounts/${accountId}/content`}>
          <NavItemIcon icon={<CompassIcon size={20} />} />
          <label>News</label>
        </NavItem>
      )}

      <NavItem to={`/accounts/${accountId}/analytics`}>
        <NavItemIcon icon={<AnalyticsIcon size={20} />} />
        <label>Analytics</label>
      </NavItem>
    </NavItemList>
  );
});

export default MainNavigation;
